import './App.css';
import AdvertiserRoutes from './Routes/AdvertiserRoutes.jsx';
import { ToastContainer } from 'react-toastify';
import React, { useEffect, useState, useRef } from 'react';
import { connect, useDispatch } from "react-redux";
import { headerIndexAction } from './Redux/Actions/apiActions.js'
import { ThemeProvider } from "styled-components";
import { GlobalStyles } from "./GlobalStyles";
// import { useDispatch } from "react-redux";
import HelmetDetails from "./components/HelmetDetails";
import 'bootstrap/dist/css/bootstrap.css';
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import "react-toastify/dist/ReactToastify.css";
import { useLocation } from "react-router-dom";

function App({ headerSetting, themeMode }) {
  // console.log("headerSetting", headerSetting);
  const dispatch = useDispatch();
  const location = useLocation();
  const accessToken = localStorage.getItem("access_token");
  // useEffect(() => {
  //   if (window.location.protocol === "https:") {
  //     const httpURL = "http://" + window.location.host + window.location.pathname + window.location.search;
  //     window.location.href = httpURL;
  //   }
  // }, []);

  useEffect(() => {
    dispatch(headerIndexAction());
  }, [dispatch, accessToken, location.pathname]);


  useEffect(() => {
    const currentHost = window.location.hostname.toLowerCase();
    const currentProtocol = window.location.protocol;
    const currentUrl = window.location.href;

    // Skip redirect for ALL localhost variations and IP addresses (development)
    if (currentHost.includes('localhost') ||
      currentHost === '127.0.0.1' ||
      /^\d+\.\d+\.\d+\.\d+/.test(currentHost) ||
      currentHost === 'www.localhost') {
      console.log('[Canonical Redirect] Skipping redirect for development host:', currentHost);
      return;
    }

    // Apply to any domain (not just specific domains)
    const bareHost = currentHost.replace(/^www\./i, '');  // remove leading www.
    if (bareHost && bareHost.length > 0) {
      const isWww = /^www\./i.test(currentHost);
      const isHttps = currentProtocol === 'https:';

      // Redirect if: www present OR protocol is not https
      if (isWww || !isHttps) {
        const targetUrl = `https://${bareHost}${window.location.pathname}${window.location.search}${window.location.hash}`;
        console.log('[Canonical Redirect] Redirecting from', currentUrl, 'to', targetUrl);

        // Use window.location.replace for a clean redirect (no history entry)
        window.location.replace(targetUrl);
        return; // Stop further execution
      }
    }
  }, []); // Run only once on mount

  return (
    <>
      <ThemeProvider theme={themeMode}>
        <GlobalStyles />
        <div>
          <div className='heightBody'>
            {/* <HelmetDetails pageTitle={metaTitle.toUpperCase()} metaTitle={metaTitle.toUpperCase()} metaDescription={headerSetting?.website_description?.toString().substring(0, 100)} />*/}
            <HelmetDetails />
            <ToastContainer position="top-right" autoClose={3000} hideProgressBar={false} closeOnClick theme='colored' />
            {/* Remove BrowserRouter here */}
            <AdvertiserRoutes />
          </div>
        </div>
      </ThemeProvider>
    </>
  );
}

const mapStateToProps = state => ({
  themeMode: state.get_headerIndex_Reducer.themeMode,
  headerSetting: state.get_headerIndex_Reducer.headerSetting,
});

export default connect(mapStateToProps)(App);
